import { render } from "./SospensioniRichiesteTable.vue?vue&type=template&id=3d8aa5e4&scoped=true"
import script from "./SospensioniRichiesteTable.vue?vue&type=script&lang=js"
export * from "./SospensioniRichiesteTable.vue?vue&type=script&lang=js"

import "./SospensioniRichiesteTable.vue?vue&type=style&index=0&id=3d8aa5e4&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8aa5e4"]])

export default __exports__